import * as AuthConstants from '../../action/auth/AuthConstants';
import { UUID } from '../../../middleware/api';

const initialState = {
  tokenIsFetching: false,
  logoutIsFetching: false,
  logoutErrorMessage: '',
  // authStatus: JSON.parse(localStorage.getItem(`${UUID}-token`)) || false,
  token: localStorage.getItem(UUID) || null,
  loginFailed: false,
  userInfo: {},
  userInfoIsFetching: false,
  userInfoErrorMessage: ''
};

export const auth = (state = initialState, action) => {
  switch (action.type) {
    // LOGIN
    case AuthConstants.LOGIN_REQUEST:
      return {
        ...state,
        tokenIsFetching: true
      };

    case AuthConstants.LOGIN_SUCCESS:
      action.data.accessToken &&
        localStorage.setItem(UUID, action.data.accessToken);
      return {
        ...state,
        // token: action.data.token,
        authStatus: action.data.accessToken,
        token: action.data.accessToken ? action.data.accessToken : null,
        tokenIsFetching: false
      };

    case AuthConstants.LOGIN_FAILED:
      return {
        ...state,
        tokenIsFetching: false,
        loginFailed: true
      };

    case AuthConstants.LOGIN_CLEAR:
      return {
        ...state,
        tokenIsFetching: false,
        loginFailed: false
      };

    case AuthConstants.GET_USER_INFO_REQUEST:
      return {
        ...state,
        userInfoIsFetching: true,
        userInfoErrorMessage: ''
      };

    case AuthConstants.GET_USER_INFO_SUCCESS:
      return {
        ...state,
        userInfo: action.data,
        userInfoIsFetching: false
      };

    case AuthConstants.GET_USER_INFO_FAILED:
      return {
        ...state,
        userInfoIsFetching: false,
        userInfoErrorMessage: 'SERVER_ERROR'
      };

    case AuthConstants.GET_USER_INFO_CLEAR:
      return {
        ...state,
        userInfoIsFetching: false,
        userInfoErrorMessage: ''
      };

    case AuthConstants.LOGOUT_REQUEST:
      return {
        ...state,
        logoutIsFetching: true,
        logoutErrorMessage: ''
      };
    case AuthConstants.LOGOUT_SUCCESS:
      localStorage.removeItem(UUID);
      return {
        ...state,
        logoutIsFetching: false
      };

    case AuthConstants.LOGOUT_FAILED:
      return {
        ...state,
        logoutIsFetching: false,
        logoutErrorMessage: 'SERVER ERROR'
        // logoutErrorMessage: action.error.response.data,
      };

    case AuthConstants.TOKEN_CLEAR:
      localStorage.removeItem(UUID);
      return {
        ...state,
        logoutIsFetching: false
      };

    default:
      return state;
  }
};
